import { useQuery } from "@tanstack/react-query";

import { evaluationCriteriaKeys } from "@/application/query-keys/evaluation-criteria.keys";
import { evaluationCriteriaRepository } from "@/infrastructure/repositories/evaluation-criteria.supabase.repository";

export function useEvaluationCriteria() {
  return useQuery({
    queryKey: evaluationCriteriaKeys.list(),
    queryFn: () => evaluationCriteriaRepository.list(),
  });
}
